import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles

const ModalCondicion = ({ estado, typeModal, onCloseModal, onReturnValue, item, isnew }) => {
  const [formData, setFormData] = useState({
    cod: item?.cod || "",
    condicion: item?.condicion || "",
    idcondiciones: item?.idcondiciones || ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, condicion: value }));
  };

  const handleSubmit = () => {
    if (!formData.cod || !formData.condicion) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Los campos código y condición son obligatorios.",
        confirmButtonColor: "#00273a",
      });
      return;
    }
    onReturnValue(formData, isnew, typeModal);
  };

  // Quill modules for toolbar customization: only bold, underline, color
  const modules = {
    toolbar: [
      ['bold', 'underline'],
      [{ color: ['#000000', '#FF0000', '#0000FF', '#008000', '#FFA500'] }],
      ['clean']
    ]
  };

  // Only allow bold, underline, color
  const formats = [
    'bold', 'underline', 'color'
  ];

  return (
    <Modal show={estado} onHide={onCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>{isnew ? "Agregar Condición" : "Editar Condición"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Código</Form.Label>
            <Form.Control
              type="text"
              name="cod"
              value={formData.cod}
              onChange={handleChange}
              placeholder="Ingrese el código"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Condición</Form.Label>
            <ReactQuill
              value={formData.condicion}
              onChange={handleQuillChange}
              modules={modules}
              formats={formats}
              style={{ height: "400px", marginBottom: "40px" }}
              placeholder="Ingrese la condición (solo negrita, color o subrayado)"
            />
            <Form.Text muted>
              Sólo se permite <b>negrita</b>, <span style={{color:'#FF0000'}}>colores</span> o <u>subrayado</u>.
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCondicion;